export const hideInitialLoader = () => {
  const loader = document.getElementById('initial-loader');
  if (!loader) return;

  loader.classList.add('initial-loader--hidden');
  window.setTimeout(() => loader.remove(), 300);
};
